import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Bars } from "react-loader-spinner";

import classes from './loader.module.css'

export default function Loader(props){
    const {label, color = '#004A95', width = 40, height = 40, ...restProps} = props
    return(
        <div className={classes.root}>
            <div style={{color}} className={classes.label}>{label}</div>
            <div className={classes.loader_root}>
                <Bars width={width} height={height} color={color}/>
            </div>
        </div>
    )
}